//
// Setup the namespace for this logic
var makePedestrianPIPLimitIPDTRCall = makePedestrianPIPLimitIPDTRCall || {};


makePedestrianPIPLimitIPDTRCall.initialize = function() {
	ap.consoleInfo("makePedestrianPIPLimitIPDTRCall initialize!");

	var field = page.getField("VehInfoNoFaultCovPedestrianPersInjuryProt");
	if (field!=null) {
		field.makeIntraPageDTRRequest();
	}
};
